import { Button, Menu, Modal } from "antd";
import { NavLink, useLocation } from "react-router-dom";
import { PRIMARY_COLOR, SECONDARY_COLOR } from "../../utils/colors";
import {
  FaUser,
  FaSignOutAlt,
} from "react-icons/fa";
import { useTranslation } from "react-i18next";
import { useUser } from "../../contexts/User";
import { useState } from "react";

function Sidenav({ navItems }) {
  const { user, logout } = useUser();
  const { pathname } = useLocation();
  const page = pathname.replace("/", "");
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);

  function handleCancel() {
    setVisible(false);
  }


  return (
    <>
      <div className="brand">
        <img
          src={`${process.env.PUBLIC_URL}/imgs/logo.png`}
          style={{ width: "80px", height: "auto" }}
          alt="Logo"
        />
      </div>

      <div
        className="alert my-4"
        style={{
          background: "gainsboro",
          padding: "10px",
          display: "flex",
          alignItems: "center",
        }}
      >
        <div
          style={{
            width: "40px",
            height: "40px",
            borderRadius: "50%",
            backgroundColor: "transparent",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontWeight: "bold",
            fontSize: "16px",
            color: PRIMARY_COLOR,
            marginRight: "10px",
            border: `2px solid ${PRIMARY_COLOR}`,
          }}
        >
          {user.email.split('@')[0].split('.').map(name => name[0].toUpperCase()).join('')}

        </div>
        <span style={{ fontSize: "18px", fontWeight: "normal" }}>
          {user.email.split('@')[0].toLowerCase()}
        </span>
      </div>

      <hr />
      <Menu theme="light" mode="inline">
        
        
        {/* Populate  */}
      {navItems.map((item, index) => (
        <Menu.Item key={index}>
          <NavLink to={item.path} style={{ background: page === item.path? "gainsboro" : "" }}>
            <span className="icon" style={{ background: page === item.path? PRIMARY_COLOR : "" }}>
              {item.icon}
            </span>
            <span className="label">{item.label}</span>
          </NavLink>
       </Menu.Item>
      ))}



        <Menu.Item className="menu-item-header" key="5">
          Account
        </Menu.Item>
        <Menu.Item key="4">
          <NavLink to="/profile" style={{ background: page === "profile" ? "gainsboro" : "" }}>
            <span className="icon" style={{ background: page === "profile" ? PRIMARY_COLOR : "" }}>
              <FaUser />
            </span>
            <span className="label">{t("sidenav.profile")}</span>
          </NavLink>
        </Menu.Item>
        <Menu.Item key="6">
          <NavLink
            onClick={() => setVisible(true)}
            style={{ background: "transparent" }}
          >
            <span className="icon" style={{ background: "red" }}>
              <FaSignOutAlt />
            </span>
            <span className="label">{t("sidenav.logout")}</span>
          </NavLink>
        </Menu.Item>
      </Menu>
      <Modal
        title={ t("logout.logout")}
        visible={visible}
        onCancel={handleCancel}
        centered
        width={300}
        footer={[
          <Button key="no" onClick={handleCancel}>
            { t("logout.No")}
          </Button>,
          <Button
            key="yes"
            type="primary"
            style={{ background: SECONDARY_COLOR, border: "none", outline: "none" }}
            onClick={() => {
              logout();
              window.location.href = "/auth/login";
            }}
          >
            { t("logout.yes")}
          </Button>,
        ]}
      >
        <center>
           <img
            src={`${process.env.PUBLIC_URL}/imgs/logout.svg`}
            style={{ width: "80px", height: "auto" }}
            alt="Logo"
          />
          <h4 className="text-muted" style={{ fontWeight: "normal", fontSize: 20}}>{ t("logout.areyousureyouwanttologout?")} </h4>
        </center>
       

      </Modal>
    </>
  );
}

export default Sidenav;
